import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const LocationPointerOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M19.87 9.37c-.35-2.57-1.9-4.95-4.09-6.26A7.774 7.774 0 0 0 11.81 2c-.64 0-1.27.08-1.89.26-2.05.59-3.77 2.15-4.81 4.05-.8 1.46-1.23 3.15-1.09 4.82.37 4.17 3.97 7.63 6.83 10.26.23.21.46.42.75.54.13.05.26.08.39.08.3 0 .61-.12.84-.33 1.96-1.74 3.63-3.65 5.24-5.71 1.12-1.42 1.77-3.21 1.86-5.04.03-.52 0-1.04-.07-1.56h.01Zm-1.53 1.48a7.27 7.27 0 0 1-1.52 4.13c-1.75 2.24-3.25 3.88-4.82 5.29-.03-.02-.05-.05-.07-.06-3.03-2.78-6.01-5.78-6.32-9.22-.11-1.26.21-2.65.9-3.91.9-1.64 2.3-2.84 3.85-3.28.46-.13.95-.2 1.45-.2 1.08 0 2.19.31 3.15.89 1.77 1.06 3.04 3.01 3.32 5.1.06.41.07.84.05 1.27l.01-.01Z" />
      <Path d="M12 5.42c-2.26 0-4.09 1.83-4.09 4.09S9.74 13.6 12 13.6s4.09-1.83 4.09-4.09S14.26 5.42 12 5.42ZM12 12c-1.37 0-2.49-1.12-2.49-2.49S10.63 7.02 12 7.02s2.49 1.12 2.49 2.49S13.37 12 12 12Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default LocationPointerOutlined
